module.exports = __webpack_public_path__ + "img/account.70d2db38.svg";